import { useSelector } from 'react-redux';

export const useCustomerInformationBlock = () => {
    //@ts-ignore
    const { financial_info, is_customer } = useSelector((store) => store.dashboardReducer);
    return { financial_info, is_customer };
};
